/**
 * IPASS tab — clinical handoff summary with color-coded sections.
 */
import { FC } from 'react'
import type { PatientPanelData } from '../types'
import { IPASSSection } from '../../chat/patient-panel/IPASSSection'
import { PanelSkeleton } from '../shared/PanelSkeleton'

export const IPASSTab: FC<{ data: PatientPanelData }> = ({ data }) => {
  // Loading state
  if (data.isGenerating && !data.ipassSource) {
    return (
      <div className="flex-1 overflow-y-auto custom-scrollbar p-3">
        <PanelSkeleton lines={8} />
      </div>
    )
  }

  return (
    <div className="flex-1 overflow-y-auto custom-scrollbar p-3">
      <IPASSSection source={data.ipassSource} />
    </div>
  )
}
